import { render, staticRenderFns } from "./sidang.vue?vue&type=template&id=79481a5b&"
import script from "./sidang.vue?vue&type=script&lang=js&"
export * from "./sidang.vue?vue&type=script&lang=js&"
import style0 from "./sidang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports